import React from 'react';

const ABOUT_HERO_BG = `${process.env.PUBLIC_URL || ''}/images/section-images/${encodeURIComponent('homeaboutus.jpg')}`;

export default function AboutHero(): React.ReactElement {
  return (
    <section
      id="about"
      className="relative isolate overflow-hidden bg-slate-900"
      style={{
        backgroundImage: `url("${ABOUT_HERO_BG}")`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className="absolute inset-0 bg-slate-950/60" />

      <div className="relative z-10 mx-auto flex min-h-[100vh] w-full max-w-7xl flex-col justify-end gap-8 px-4 pb-2 pt-32 sm:px-6 sm:pb-4 sm:pt-40 lg:px-12 lg:pb-6 lg:pt-48">
        <div className="max-w-3xl text-left text-white">
          <h1 className="mt-4 text-4xl font-semibold leading-tight sm:text-5xl lg:text-6xl">
            About Ancient Engineering
          </h1>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-white/85 sm:text-lg">
            Delivering innovative, agile, and affordable engineering solutions across Mining, Construction,
            and Manufacturing in Zimbabwe. Our experienced team ensures quality, safety, and efficiency
            in every project.
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="/contact"
              className="inline-flex w-full items-center justify-center rounded-md bg-white px-6 py-3 text-sm font-semibold text-slate-900 shadow-sm transition-colors hover:bg-white/90 sm:w-auto"
            >
              Contact Us
            </a>
            <a
              href="/services"
              className="inline-flex w-full items-center justify-center rounded-md border border-white/60 bg-transparent px-6 py-3 text-sm font-semibold text-white shadow-sm transition-colors hover:border-white hover:bg-white/10 sm:w-auto"
            >
              Our Services
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

